import { render, staticRenderFns } from "./SpinnerLottie.vue?vue&type=template&id=f8c0685a&scoped=true"
import script from "./SpinnerLottie.vue?vue&type=script&lang=js"
export * from "./SpinnerLottie.vue?vue&type=script&lang=js"
import style0 from "./SpinnerLottie.vue?vue&type=style&index=0&id=f8c0685a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c0685a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8c0685a')) {
      api.createRecord('f8c0685a', component.options)
    } else {
      api.reload('f8c0685a', component.options)
    }
    module.hot.accept("./SpinnerLottie.vue?vue&type=template&id=f8c0685a&scoped=true", function () {
      api.rerender('f8c0685a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Spinners/SpinnerLottie.vue"
export default component.exports